export const COUNTRY_STORAGE_KEY = "toposfy_visitor_country";

const TIMEZONE_COUNTRY = {
  "Africa/Lagos": "NG",
  "Africa/Kinshasa": "CD",
  "Africa/Lubumbashi": "CD",
};

let cachedCountry = "";
let inflight = null;

export function parseTraceCountry(text) {
  const match = String(text || "").match(/^loc=([A-Z]{2})$/m);
  return match ? match[1] : "";
}

export function countryFromTimezone(timeZone) {
  const zone =
    timeZone ||
    (typeof Intl !== "undefined"
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : "");
  return TIMEZONE_COUNTRY[zone] || "";
}

async function readTraceCountry(url, signal) {
  const res = await fetch(url, { cache: "no-store", signal });
  if (!res.ok) {
    return "";
  }
  return parseTraceCountry(await res.text());
}

export function countryFromQuery(searchOrHash) {
  const sources = [];
  if (searchOrHash != null && searchOrHash !== "") {
    sources.push(searchOrHash);
  } else if (typeof window !== "undefined") {
    sources.push(window.location.hash, window.location.search);
  }
  for (const raw of sources) {
    if (!raw || !String(raw).includes("?")) {
      continue;
    }
    const query = String(raw).slice(String(raw).indexOf("?"));
    const loc = new URLSearchParams(query).get("loc");
    if (loc) {
      return loc.toUpperCase();
    }
  }
  return "";
}

export function persistCountry(code) {
  const value = String(code || "").toUpperCase();
  if (!/^[A-Z]{2}$/.test(value)) {
    return "";
  }
  cachedCountry = value;
  try {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(COUNTRY_STORAGE_KEY, value);
    }
  } catch (err) {
    // Ignore private-mode / blocked storage.
  }
  return value;
}

export function readCachedCountry() {
  if (cachedCountry) {
    return cachedCountry;
  }
  try {
    if (typeof sessionStorage !== "undefined") {
      cachedCountry = sessionStorage.getItem(COUNTRY_STORAGE_KEY) || "";
    }
  } catch (err) {
    cachedCountry = "";
  }
  return cachedCountry;
}

export function resetCountryDetection() {
  cachedCountry = "";
  inflight = null;
  try {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.removeItem(COUNTRY_STORAGE_KEY);
    }
  } catch (err) {
    // Ignore.
  }
}

async function detectFreshCountry() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 2000);
  try {
    for (const url of ["/cdn-cgi/trace", "https://www.cloudflare.com/cdn-cgi/trace"]) {
      try {
        const loc = await readTraceCountry(url, controller.signal);
        if (loc) {
          return loc;
        }
      } catch (err) {
        if (err && err.name === "AbortError") {
          break;
        }
      }
    }
  } finally {
    clearTimeout(timer);
  }
  return countryFromTimezone();
}

export async function detectVisitorCountry() {
  const fromQuery = countryFromQuery();
  if (fromQuery) {
    persistCountry(fromQuery);
    return fromQuery;
  }
  const cached = readCachedCountry();
  if (cached) {
    return cached;
  }
  if (inflight) {
    return inflight;
  }
  inflight = detectFreshCountry()
    .then((code) => {
      if (code) {
        persistCountry(code);
      }
      return code || "";
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function officeCountry(code) {
  return code === "NG" ? "NG" : "CD";
}
